export const AFTER_QUERY_SUGGEST_LAYER = 'search-box-aqsl'
export const PDP_COMPACT_PRESCRIPTION_TYPES_COM =
  'pdp-compact-prescription-types-com'
export const PDP_COMPACT_PRESCRIPTION_TYPES_AT_IT =
  'pdp-compact-prescription-types-at-it'
export const ALT_SERP_AT = 'new-serp-layout-at'
export const RELEASE_SWITCH_TOGGLE = 'release-switch'
export const RELEASE_TOGGLE_SAE_ONLY = 'sae-only'
export const RELEASE_TOGGLE_MARKETPLACE = 'marketplace'
export const PRE_QUERY_SUGGEST_NAME = 'search-box-pqsl'
export const PDP_XSELL_TOP = 'pdp-with-xsell-on-top'
